import React, { useState } from 'react';
import Field from '../../fields/Field';
import ReactLoading from 'react-loading';
import { createAlert } from '../../../dom/window';
import { getTranslation } from '../../../lang/main';
import $ from 'jquery';


function OrderUpdateFreightForm(props) {
    const {
        onSubmit,
    } = props;

    const [freightAmount, setFreightAmount] = useState(null);
    const [trackingNumber, setTrackingNumber] = useState('');
    const [updateInProcess, setUpdateInProcess] = useState(false);
    const orderID = window.orderid || null;

    const validateDecimal = (value) => {

        const regex = /^\d{0,6}(\.\d{0,2})?$/
        return regex.test(value)
    }

    const handleFreightAmountChange = (value) => {
        if (validateDecimal(value) || value === '') {
            setFreightAmount(value)
        }

    }

    const handleCancelOrder = () => {
        $('#order-calculation-section').show();
        $('#update-order-freight-section').hide();
    }

    const handleUpdateOrder = () => {
        if (validateUpdateFreight()) {
            setUpdateInProcess(true);
            let params = {
                FreightAmount: Number(freightAmount),
                TrackingNumber: trackingNumber,
                OrderID: orderID,
            };
            onSubmit(params, {
                success: () => {
                    createAlert(
                        {
                            message: getTranslation(
                                'Freight Updated Successfully.'
                            ),
                        },
                        'success'
                    );
                    setFreightAmount(null);
                    setUpdateInProcess(false);
                    window.location.reload();
                },
                error: () => {
                    setUpdateInProcess(false);
                }
            });
        }
    }

    const validateUpdateFreight = () => {
        if (freightAmount === null || freightAmount === '') {
            createAlert(
                {
                    message: getTranslation(
                        'Invalid Freight Amount'
                    ),
                },
                'error'
            );
            return false;
        }
        return true;
    }

    return (
        <React.Fragment>
            <>
                <div>
                    <Field
                        required={true}
                        label='Freight Amount'
                        animatedLabel='Freight Amount'
                        name='FreightAmount'
                        value={freightAmount || ''}
                        onChange={e => {
                            handleFreightAmountChange(e.target.value)
                        }}
                    />
                </div>
                <div>
                    <Field
                        required={false}
                        label='Tracking Number'
                        animatedLabel='Tracking Number'
                        name='TrackingNumber'
                        value={trackingNumber || ''}
                        onChange={e => {
                            setTrackingNumber(e.target.value)
                        }}
                    />
                </div>
                <div className='row'>
                    <div className='col-sm-6'>
                        <button
                            disabled={updateInProcess}
                            className="button button--fullwidth"
                            onClick={() => handleUpdateOrder()}
                            style={{ position: 'relative' }}
                        >
                            <span
                                style={{
                                    opacity: updateInProcess ? 0 : 1,
                                }}
                            >
                                Update Order
                            </span>
                            {updateInProcess &&
                                <ReactLoading
                                    className='button__spinner'
                                    type='spin'
                                    color='white'
                                    height={20}
                                    width={20}
                                />
                            }
                        </button>
                    </div>
                    <div className='col-sm-6'>
                        <button
                            disabled={updateInProcess}
                            className="button button--grey button--fullwidth col-sm-6"
                            onClick={() => handleCancelOrder()}
                        >
                            <span>
                                Cancel
                            </span>
                        </button>
                    </div>
                </div>

            </>
        </React.Fragment >
    );
}

// default props
OrderUpdateFreightForm.defaultProps = {
    // message: '',
};
// validate props
OrderUpdateFreightForm.propTypes = {
    // message: PropTypes.string,
};

export default OrderUpdateFreightForm;
